import React from 'react';
import MonthRangePciker from 'components/MonthRangePicker';
import {
    RANGE_MOTHN,
    RANGE_CURRENT_HALF_YEAR,
    RANGE_CURRENT_YEAR,
    RANGE_THIS_YEAR
} from 'utils/const';
import {disabledMonthAfterNow} from 'utils/tool';
class BaseRangePicker extends React.Component {

    constructor(props){
        super(props);
        this._default6 = RANGE_CURRENT_HALF_YEAR;
        this._default12 = RANGE_CURRENT_YEAR;
        this._defaultYear = RANGE_THIS_YEAR;
        this.state = {
            selectTime : this.props.defaultValue?this.props.defaultValue:RANGE_MOTHN
        };
    }

    changeSelectTime(times){
        this.setState({selectTime:times});
    }

    timeChange = (e)=>{
        if(e.length === 0) {
            return;
        }
        this.props.onChange && this.props.onChange(e);
        this.setState({selectTime:e});
    }

    getSelectTime(){
        return this.state.selectTime;
    }
    render(){
        const _disabledDate = (current) => disabledMonthAfterNow(current);
        return (
            <MonthRangePciker
                ranges={{'This year': this._defaultYear, 'Half a year': this._default6,'One year':this._default12 }}
                style={{width:280}}
                format='YYYY-MM'
                allowClear={false}
                onChange={this.timeChange}
                value={this.state.selectTime}
                disabledDate={_disabledDate}/>
        );
    }
}
export default BaseRangePicker;



// WEBPACK FOOTER //
// ./src/components/BaseRangeMonthPicker/index.js